import {Component, ViewEncapsulation} from '@angular/core';
import {Angulartics2GoogleAnalytics} from "angulartics2/ga";

@Component({
             selector   : 'sis-app',
             template: require('./app.component.html'),
             encapsulation: ViewEncapsulation.None
           })
export class AppComponent {

  constructor(angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics) {
    //yes, we need it
  }
}
